import devload from "../../assets/hero/illustration/gdg.png";
import   "./Loader.css";

function Loader(){
    return(
        <div className="loader-container"
        >
            <img src={devload} width={400} alt="GDG Loader" className="loadimg" />
        </div>

    );

}

export default Loader;